import { __module as reactIs, exports as reactIsExports } from '../../../../_virtual/index6.js';
import { __require as requireReactIs_production_min } from './cjs/react-is.production.min.js';
import { __require as requireReactIs_development } from './cjs/react-is.development.js';
(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = requireReactIs_production_min();
  } else {
    module.exports = requireReactIs_development();
  }
})(reactIs);
//# sourceMappingURL=index.js.map
